import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation, useParams } from 'react-router-dom'
import {
    Alert,
    Fade,
    Snackbar,
    Box,
} from '@mui/material'
import { useAuthInfo } from '@propelauth/react'
import DescriptionStepComponent from './steps/DescriptionStepComponent'
import ComplexLoaderComponent from '../../components/ComplexLoaderComponent'
import SourceSelectionModal from './steps/SourceSelectionModal'
import {
    getOutlineFromTemplates,
    listAllFiles,
    extractAndStoreTFLTables,
    generateDocumentId,
    initialDocumentGeneration,
    listAllMRTTemplates,
    extractAndClassifyDocuments,
    batchIngestDocuments,
    concatenateTFLFiles,
    fullBatchIngestionAsync,
    ingestAndGenerateDocument,
    extractIngestAndOrchestrateMRT,
    pkTabulatedSummaryGenerationAsync,
    txTabulatedSummaryGenerationAsync,
    pharmTabulatedSummaryGenerationAsync
} from '../../utils/utils'
import '../../App.css' 
import { useDemo } from '../../contexts/DemoContext'
import { useUser } from '../../contexts/UserContext'
import HorizontalStepper from '../../components/steppers/HorizontalStepper'
import SelectDocumentSectionToBeGenerated from './steps/modals/SelectDocumentSectionToBeGenerated'
import CustomStepper from '../../components/CustomStepper'
import DocumentReviewComponent from './steps/DocumentReviewComponent'
import { DocumentCreationProvider } from '../../contexts/DocumentCreationContext'
import UploadSourcesStepComponent from './steps/UploadSourcesStepComponent'
import { useDocumentCreation } from '../../contexts/DocumentCreationContext'
import DatabaseQuerySelection from './steps/DatabaseQuerySelection'
import GeneratingDocumentModal from './steps/modals/GeneratingDocumentModal'
import { v4 as uuidv4 } from 'uuid'

const START_STEP = 0
const DEMO_MODE = true

export default function CreateDocumentPage() {
    // Document Set Id
    const { documentSetId } = useParams()

    const { document, updateDocument } = useDocumentCreation()

    // Step States
    const [step, setStep] = useState(START_STEP)

    const location = useLocation()
    const { id: documentId } = location.state || {}
    

    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState(false)

    // Document Description States
    const [documentName, setDocumentName] = useState('')
    const [productName, setProductName] = useState('')
    const [templateType, setTemplateType] = useState({})
    const [template_file_name, setTemplateFileName] = useState('')

    // Selected Files
    const [multipleFileList, setMultipleFileList] = useState([])
    const [multipleFileNameList, setMultipleFileNameList] = useState([])
    const [multipleFileContentList, setMultipleFileContentList] = useState([])
    const [multipleContextFileList, setMultipleContextFileList] = useState([])
    const [multipleContextFileNameList, setMultipleContextFileNameList] = useState([])
    const [contentPlanFileList, setContentPlanFileList] = useState([])
    const [contentPlanNameList, setContentPlanNameList] = useState([])
    const [contentPlanContentList, setContentPlanContentList] = useState([])
    const [tflFileList, setTFLFileList] = useState([])
    const [tflFileNameList, setTFLFileNameList] = useState([])
    const [tflFileContentList, setTFLFileContentList] = useState([])
    const [selectedTFLCloudFiles, setSelectedTFLCloudFiles] = useState([])
    const [selectedTFLCloudFileNames, setSelectedTFLCloudFileNames] = useState(
        []
    )

    const [outlineSections, setOutlineSections] = useState([])
    const [initialOutlineSections, setInitialOutlineSections] = useState([])
    const [rules, setRules] = useState([])
    const [updatedRules, setUpdatedRules] = useState([])
    const [templateTypes, setTemplateTypes] = useState([])
    const [sourceModalOpen, setSourceModalOpen] = useState(false)
    const [contextModalOpen, setContextModalOpen] = useState(false)
    const [tflModalOpen, setTFLModalOpen] = useState(false)
    const [inputFiles, setInputFiles] = useState([])
    const [selectedCloudFiles, setSelectedCloudFiles] = useState([])
    const [selectedContextCloudFiles, setSelectedContextCloudFiles] = useState([])
    const [selectedCloudFileNames, setSelectedCloudFileNames] = useState([])
    const [selectedContextCloudFileNames, setSelectedContextCloudFileNames] = useState([])
    const [showPkTables, setShowPkTables] = useState(false)
    const [enableBulkUpload, setEnableBulkUpload] = useState(false)
    const [showComplexLoader, setShowComplexLoader] = useState(false)
    const [rulesetList, setRulesetList] = useState([])

    // Snackbar States
    const [snackbarOpen, setSnackbarOpen] = useState(false)
    const [snackbarMessage, setSnackbarMessage] = useState('')

    const [isDocumentTypeLoading, setIsDocumentTypeLoading] = useState(true)

    // Generating Document Modal States
    const [generatingDocumentModalOpen, setGeneratingDocumentModalOpen] = useState(false)

     
    //                     DocGen              Loading                Response
    // Waiting     ->     Creating     ->     Generating     ->    (Success/Error)  ->   Waiting
    //    0 -> Create Doc -> 1 -> Confirm Info -> 2 -> Recieve Response -> 3 -> Back to -> 0
    //                           POST API Call
    
    const [status, setStatus] = useState('waiting')
    const [progress, setProgress] = useState(0)

    const { isDemo } = useDemo()

    const navigate = useNavigate()
    const auth = useAuthInfo()
    const orgs = auth.orgHelper.getOrgs()
    const org = orgs[0].orgId

    const { roles } = useUser()
    const userRoles = roles

    useEffect(() => {
        const shouldShowPkTables =
            (templateType?.type === 'Module 2.6 PK Table 2.6.5.1' ||
                templateType?.type === 'Module 2.6 PK Table 2.6.5') &&
            // Replace with Biohaven org Id
            org === '12345'
        setShowPkTables(shouldShowPkTables)
    }, [templateType, org])

    // useEffect(() => {
    //     async function fetchRulesets() {
    //         const orgAccessToken = await getOrgAccessToken(org)
    //         const rulesets = await getAllRulesets(orgAccessToken)
    //         console.log('rulesets:', rulesets)
    //         setRulesetList(rulesets)
    //     }
    //     fetchRulesets()
    // }, [templateType])

    // Steps
    const [steps, setSteps] = useState([])
    
    useEffect(() => {
        console.log("document", document)
        console.log("document.selectedSections", document.selectedSections)
    }, [document])

    useEffect(() => {
        setStatus('waiting')
    }, [])

    useEffect(() => {
        let baseSteps = ['Description', 'Sources', 'Review']
        console.log('templateType.detected_document_type', templateType.detected_document_type !== undefined)
        console.log('templateType', templateType)
        if (templateType.detected_document_type !== undefined && !(templateType.detected_document_type || '').includes('Tabulated Summary')) {
            baseSteps = ['Description', 'Sections', 'Sources', 'Review']
        }
        setSteps(baseSteps)
    }, [enableBulkUpload, showPkTables, templateType])

    useEffect(() => {
        if (selectedCloudFiles.length > 0) {
            updateDocument({referenceFiles: [...selectedCloudFiles]})
        } else {
            updateDocument({referenceFiles: []})
        }
    }, [selectedCloudFiles, updateDocument])
    
    const handleStepChange = async (direction) => {
        const newStep = step + direction
        if (newStep >= 0 && newStep < steps.length) {
            if (direction > 0 && !validateStep(step)) {
                return
            }
            setStep(newStep)
            await stepPostProcessing(newStep)
        }
    }

    const handleFileUpload = (files, fileContents) => {
        const newFiles = files.map((file, index) => ({
            name: file.name,
            content: fileContents[index],
        }))
        addUniqueFiles(newFiles, false)
    }

    const handleTFLFileUpload = (files, fileContents) => {
        const newFiles = files.map((file, index) => ({
            name: file.name.replace(`${org}/input/`, ''),
            content: fileContents[index],
        }))
        setTFLFileList((prevFiles) => {
            const uniqueNewFiles = newFiles.filter(
                (newFile) =>
                    !prevFiles.some(
                        (prevFile) => prevFile.name === newFile.name
                    )
            )
            return [...prevFiles, ...uniqueNewFiles]
        })

        setTFLFileNameList((prevList) => {
            const uniqueNewNames = newFiles
                .map((file) => file.name)
                .filter((name) => !prevList.includes(name))
            return [...prevList, ...uniqueNewNames]
        })

        setTFLFileContentList((prevContents) => [
            ...prevContents,
            ...fileContents,
        ])
    }

    const handleCloudFileSelect = (selectedFiles) => {
        const newFiles = selectedFiles.map((file) => ({
            name: file.name,
            // Add any other necessary properties for cloud files
        }))
        addUniqueFiles(newFiles, true)
    }

    const handleTFLCloudFileSelect = (selectedFiles) => {
        setSelectedTFLCloudFiles(
            selectedFiles.map((file) => ({
                name: file.name,
                isCloud: true,
            }))
        )

        const cleanFileNames = selectedFiles.map((file) => {
            const index = file.name.indexOf('/')
            return index !== -1 ? file.name.substring(index + 1) : file.name
        })
        setSelectedTFLCloudFileNames(cleanFileNames)

        setTFLFileNameList((prevList) => {
            const localFiles = prevList.filter((name) =>
                tflFileList.some((file) => file.name === name)
            )
            return [...localFiles, ...cleanFileNames]
        })
    }

    const addUniqueFiles = (newFiles, isCloudFile) => {
        const existingFiles = isCloudFile
            ? selectedCloudFiles
            : multipleFileList
        const setFiles = isCloudFile
            ? setSelectedCloudFiles
            : setMultipleFileList

        const uniqueFiles = newFiles.filter(
            (newFile) =>
                !existingFiles.some(
                    (existingFile) => existingFile.name === newFile.name
                )
        )

        if (uniqueFiles.length > 0) {
            setFiles((prevFiles) => [...prevFiles, ...uniqueFiles])
        }

        if (uniqueFiles.length < newFiles.length) {
            console.log(
                'Some files were not added because they already exist in the list.'
            )
        }
    }

    useEffect(() => {
        console.log(outlineSections)
    }, [outlineSections])

    useEffect(() => {
        async function retrieveTemplateTypes() {
            setLoading(true)
            setIsDocumentTypeLoading(true)
            try {
                const orgAccessToken = await getOrgAccessToken(orgs[0].orgId)
                const rawResult = await listAllMRTTemplates(orgAccessToken)
                console.log('Raw template types:', rawResult)
                const result = rawResult.filter(template => template.status === 'Ready')
                console.log('Template types:', result)
                setTemplateTypes(result)
                setError(false)
            } catch (error) {
                console.error(error)
                setError(true)
            } finally {
                setLoading(false)
                setIsDocumentTypeLoading(false)
            }
        }

        retrieveTemplateTypes()
    }, [])

    useEffect(() => {
        if (templateType && template_file_name) {
            fetchOutline(template_file_name)
            // Update document context with template information
            updateDocument({
                templateType: {
                    ...templateType,
                    template_name: template_file_name
                }
            })
        }
    }, [templateType, template_file_name])

    const fetchOutline = async (template_file_name) => {
        const orgAccessToken = await getOrgAccessToken(orgs[0].orgId)
        const outline = await getOutlineFromTemplates(
            template_file_name,
            templateType.nickname,
            orgAccessToken
        )
        setOutlineSections(outline)
        setInitialOutlineSections(outline)
    }

    const handleUpdateOutlineSections = (updatedSections) => {
        setOutlineSections(updatedSections)
    }

    const handleRulesChange = (newRules) => {
        setRules((rules) => newRules)
        return
    }

    useEffect(() => {
        setUpdatedRules(rules)
    }, [rules])

    const fetchFiles = async () => {
        try {
            setLoading(true)
            const orgAccessToken = await getOrgAccessToken(orgs[0].orgId)
            const files = await listAllFiles('input', orgAccessToken)
            setInputFiles(files)
        } catch (error) {
            console.error('Error fetching files:', error)
            setError(true)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (step === 1) {
            // Only fetch when on source selection step
            fetchFiles()
        }
    }, [step])

    const stepPostProcessing = async (currentStep) => {
        // Empty for now as we moved file fetching to useEffect
    }

    const handleFilesUploaded = () => {
        fetchFiles()
    }

    const handleSourceModalOpen = () => {
        setSourceModalOpen(true)
    }

    const handleSourceModalClose = () => {
        setSourceModalOpen(false)
    }

    const handleContextModalOpen = () => {
        setContextModalOpen(true)
    }

    const handleContextModalClose = () => {
        setContextModalOpen(false)
    }

    const handleTFLModalOpen = () => {
        setTFLModalOpen(true)
    }

    const handleTFLModalClose = () => {
        setTFLModalOpen(false)
    }

    const handleSourceSelect = (selectedFiles) => {
        console.log('handleSourceSelect')
        console.log('selectedFiles', selectedFiles)
        // Store full paths in selectedCloudFiles
        setSelectedCloudFiles(
            selectedFiles.map((file) => ({
                name: file.name,
                url: file.url,
                id: file.id,
                isCloud: true,
            }))
        )

        // Store clean filenames using the same cleaning method as handleGenerateDocument
        const cleanFileNames = selectedFiles.map((file) => {
            const index = file.name.indexOf('/')
            return index !== -1 ? file.name.substring(index + 1) : file.name
        })
        setSelectedCloudFileNames(cleanFileNames)

        // Update the file name list to match exactly what's selected
        setMultipleFileNameList((prevList) => {
            // Remove all cloud files first
            const localFiles = prevList.filter((name) =>
                multipleFileList.some((file) => file.name === name)
            )
            // Add all currently selected cloud files
            return [...localFiles, ...cleanFileNames]
        })
    }

    const handleContextSelect = (selectedFiles) => {
        console.log('handleContextSelect')
        console.log('selectedFiles', selectedFiles)
        setSelectedContextCloudFiles(
            selectedFiles.map((file) => ({
                name: file.name,
                isCloud: true,
            }))
        )

        const cleanFileNames = selectedFiles.map((file) => {
            const index = file.name.indexOf('/')
            return index !== -1 ? file.name.substring(index + 1) : file.name
        })
        setSelectedContextCloudFileNames(cleanFileNames)

        setMultipleContextFileList((prevList) => {
            const localFiles = prevList.filter((name) =>
                multipleContextFileList.some((file) => file.name === name)
            )
            return [...localFiles, ...cleanFileNames]
        })
    }


    const handleMultipleFiles = (files, fileContents) => {
        const newFiles = files.map((file, index) => ({
            name: file.name,
            content: fileContents[index],
            isCloud: false,
        }))
        setMultipleFileList((prevFiles) => {
            const uniqueNewFiles = newFiles.filter(
                (newFile) =>
                    !prevFiles.some(
                        (prevFile) => prevFile.name === newFile.name
                    )
            )
            return [...prevFiles, ...uniqueNewFiles]
        })

        // Update multipleFileNameList
        setMultipleFileNameList((prevList) => {
            const uniqueNewNames = newFiles
                .map((file) => file.name)
                .filter((name) => !prevList.includes(name))
            return [...prevList, ...uniqueNewNames]
        })
    }

    const handleMultipleContextFiles = (files, fileContents) => {
        const newFiles = files.map((file, index) => ({
            name: file.name,
            content: fileContents[index],
            isCloud: false,
        }))
        setMultipleContextFileList((prevFiles) => {
            const uniqueNewFiles = newFiles.filter(
                (newFile) =>
                    !prevFiles.some(
                        (prevFile) => prevFile.name === newFile.name
                    )    
            )
            return [...prevFiles, ...uniqueNewFiles]
        })

        setMultipleContextFileNameList((prevList) => {
            const uniqueNewNames = newFiles
                .map((file) => file.name)
                .filter((name) => !prevList.includes(name))
            return [...prevList, ...uniqueNewNames]
        })
    }

    const handleMultipleFilesOriginal = (files, fileContents) => {
        try {
            // Handle saving the file content or any other logic as needed for each file
            const newFiles = []
            console.log('files here', files)

            for (let i = 0; i < files.length; i++) {
                const file = files[i]
                const content = fileContents[i]
                newFiles.push({ name: file.name, content })
                console.log('newFiles', newFiles)
            }

            // Update React state with the array of file objects
            setContentPlanFileList(newFiles)
            setContentPlanNameList(newFiles.map((file) => file.name))
            setContentPlanContentList(fileContents)
        } catch (e) {
            console.log('Error in handling files', e)
        }
    }

    const removeFile = (fileName, isCloud) => { 
        if (isCloud) {
            setSelectedCloudFiles((prev) =>
                prev.filter((file) => file.name !== fileName)
            )
        } else {
            setMultipleFileList((prev) =>
                prev.filter((file) => file.name !== fileName)
            )
        }
        setMultipleFileNameList((prev) =>
            prev.filter((name) => name !== fileName)
        )
    }

    const removeTFLFile = (fileName, isCloud) => {
        if (isCloud) {
            setSelectedTFLCloudFiles((prev) =>
                prev.filter((file) => file.name !== fileName)
            )
        } else {
            setTFLFileList((prev) =>
                prev.filter((file) => file.name !== fileName)
            )
        }
        setTFLFileNameList((prev) => prev.filter((name) => name !== fileName))
    }

    const originalRemoveFile = (index) => {
        const newFileList = [...contentPlanFileList]
        newFileList.splice(index, 1)
        setContentPlanFileList(newFileList)
    }

    async function getOrgAccessToken(orgId) {
        console.log(orgId + ' is orgId')
        const orgAccessToken = await auth.tokens.getAccessTokenForOrg(orgId)
        return orgAccessToken
    }

    const handleGeneratingDocumentModalOpen = () => {
        setStatus('generating')
        setGeneratingDocumentModalOpen(true)
    }

    const handleGeneratingDocumentModalClose = async () => {
        // Reset states and navigate immediately
        setStatus('waiting')
        setLoading(false)
        setSuccess(false)
        setError(false)
        setGeneratingDocumentModalOpen(false)
        navigate(`/documentSet/${documentSetId}?success=true`)
    }

    const handleGenerateOtherDocumentType = async (finalDocument, accessToken, documentType) => {
        // A document set key is a batch id for relating the uploaded sources documents together. 
        // This will be passed through the Generation pipeline.
        // Will use a hash of document names, template name, and timestamp to create a unique key.
        const documentSetKey = uuidv4()

        // Extract file paths from document.referenceFiles
        const payloadFiles = finalDocument.referenceFiles.map(file => file.name.split('/').slice(1).join('/'))

        // Get the section ids from the document context
        const selectedSectionIds = finalDocument.selectedSections

        console.log('selectedSectionIds', selectedSectionIds)

        // Create the comprehensive payload based on user selections
        // {
        //     "document_type":"IB",
        //     "generic_mrt_id":"6865ca3a55bd6b9500db4c1e",
        //     "file_paths":["input/BHV-8100/Pharm/bhv-8100-ncph-001-final-rpt.pdf"],
        //     "document_set_key":"bhv-8100-full-4"
        // }
        const payload = {
            document_type: documentType,
            generic_mrt_id: templateType.template_id,
            selected_section_ids: selectedSectionIds,
            file_paths: payloadFiles,
            document_set_key: documentSetKey,
            document_set_name: documentSetId,
            output_name: documentName
        }

        console.log('Other document type payload:', payload)
        
        const extractIngestAndOrchestrate = await extractIngestAndOrchestrateMRT(
            payload, 
            accessToken
        )

        console.log('extractIngestAndOrchestrate:', extractIngestAndOrchestrate)
        
    }

    const handleGenerateTabulatedSummary = async (finalDocument, accessToken, documentType) => {
        // Extract file paths from document.referenceFiles
        const payloadFiles = finalDocument.referenceFiles.map(file => file.name.split('/').slice(1).join('/'))

        const payload = {
            ncr_file_paths: payloadFiles,
            connector_data_id: templateType.template_id,
            output_name: documentName,
            document_set: documentSetId,
        }

        console.log('Tabulated Summary payload:', payload)

        let response = null

        console.log('documentType', documentType)

        switch (documentType) {
            case 'Pharmacology Tabulated Summary':
                console.log('Detected: Pharmacology Tabulated Summary')
                response = await pharmTabulatedSummaryGenerationAsync(payload, accessToken)
                break

            case 'Toxicology Tabulated Summary':
                console.log('Detected: Toxicology Tabulated Summary')
                response = await txTabulatedSummaryGenerationAsync(payload, accessToken)
                break
                
            case 'Pharmacokinetics Tabulated Summary':
                console.log('Detected: Pharmacokinetics Tabulated Summary')
                response = await pkTabulatedSummaryGenerationAsync(payload, accessToken)
                break
        }

        console.log('Tabulated Summary response:', response)
    }

    const handleGenerateDocument = async (finalDocument) => {
        setLoading(true)
        handleGeneratingDocumentModalOpen() // Open modal before starting

        // Set up 10-second timeout to navigate even if request hasn't completed
        const timeoutId = setTimeout(() => {
            setStatus('success')
            setSuccess(true)
            setLoading(false)
            
            // Auto-close modal after 3 seconds
            setTimeout(() => {
                setGeneratingDocumentModalOpen(false)
                // Navigate to document set page with success flag
                navigate(`/documentSet/${documentSetId}?success=true`)
            }, 3000)
        }, 10000) // 10 seconds

        try {
            // Get the org access token
            const orgAccessToken = await getOrgAccessToken(orgs[0].orgId)

            const documentType = templateType.detected_document_type

            if (documentType.includes('Tabulated Summary')) {
                await handleGenerateTabulatedSummary(finalDocument, orgAccessToken, documentType)
            } else {
                await handleGenerateOtherDocumentType(finalDocument, orgAccessToken, documentType)
            }

            // Clear the timeout if request completes before 10 seconds
            clearTimeout(timeoutId)
            
            setStatus('success')
            setSuccess(true)
            setLoading(false)
            
        } catch (error) {
            // Clear the timeout on error as well
            clearTimeout(timeoutId)
            
            console.error('Error in document generation process:', error)
            setError(true)
            setStatus('error')
            setSnackbarMessage('Error generating document. Please try again.')
            setSnackbarOpen(true)
        } 
    }
    
    const handleGenerateDocumentDemoCall = () => {
        setLoading(true)
        setStatus('generating')
        handleGeneratingDocumentModalOpen()

        // Mock async call with at least 10 seconds delay for investor demo
        setTimeout(() => {
            setLoading(false)
            // Simulate success or error (90% success rate for demo)
            if (true) {
                setStatus('success')
                setSuccess(true)
                // ComplexLoader will auto-navigate after its own delay
                // setShowComplexLoader(true)
                setTimeout(() => {
                    handleGeneratingDocumentModalClose()
                    navigate('/')
                }, 2000)
            } else {
                setStatus('error')
                setError(true)
                setSnackbarMessage('Demo error: Document generation failed')
                setSnackbarOpen(true)
            }
        }, 10000) // 10 seconds delay as requested
    }

    // -2 because we are considering "generate document" as the last step, even though it is not a real step.
    const isLastStep = (currentStep) => currentStep === steps.length - 2

    const renderStepContent = (currentStep) => {
        if (showComplexLoader) {
            return (
                <ComplexLoaderComponent
                    onNextClick1={() => {
                        navigate('/')
                    }}
                    templateType={templateType}
                    orgId={org}
                />
            )
        }

        const stepComponents = {
            'Description': (
                <DescriptionStepComponent
                    onNextClick={() => handleStepChange(1)}
                    documentName={documentName}
                    setDocumentName={setDocumentName}
                    productName={productName}
                    setProductName={setProductName}
                    templateTypes={templateTypes}
                    templateType={templateType}
                    setTemplateType={setTemplateType}
                    loading={loading}
                    success={success}
                    setSuccess={setSuccess}
                    setLoading={setLoading}
                />
            ),
            'Sections': (
                <SelectDocumentSectionToBeGenerated
                    onNextClick={() => handleStepChange(1)}
                    onBackClick={() => handleStepChange(-1)}
                    documentName={documentName}
                    productName={productName}
                    templateType={templateType}
                    setSteps={setSteps}
                    steps={steps}
                    loading={loading}
                    success={success}
                    setSuccess={setSuccess}
                    setLoading={setLoading}
                />
            ),
            'Sources': (
                <UploadSourcesStepComponent
                    onNextClick={() => { 
                        handleStepChange(1) 
                        console.log('document', document)
                    }}
                    onBackClick={() => handleStepChange(-1)}
                    onFileSelect={handleSourceModalOpen}
                    selectedFiles={selectedCloudFiles}
                    removeFile={removeFile}
                    loading={loading}
                    success={success}
                    setSuccess={setSuccess}
                    setLoading={setLoading}
                />
            ),
            'Review': (
                <DocumentReviewComponent
                    onConfirm={handleGenerateDocument}
                    onBackClick={() => handleStepChange(-1)}
                    loading={loading}
                    success={success}
                    setSuccess={setSuccess}
                    setLoading={setLoading}
                />
            ),
            'Database Query': (
                <DatabaseQuerySelection
                    onBackClick={() => handleStepChange(-1)}
                    onConfirm={() => handleStepChange(1)}
                    loading={loading}
                    success={success}
                    setSuccess={setSuccess}
                    setLoading={setLoading}
                />
            )
        }

        return stepComponents[steps[currentStep]] || null
    }

    const validateStep = (currentStep) => {
        switch (currentStep) {
            case 0:
                if ( !documentName.trim() || !templateType ) {
                    setSnackbarMessage(
                        'Please fill out all fields before proceeding'
                    )
                    setSnackbarOpen(true)
                    return false
                }
                return true

            case 1:
                return true
                
            case 2:
                if (document.templateType.template_name === "Seasonal mRNA BSR Template") {
                    return true
                } else if (
                    multipleFileList.length === 0 &&
                    selectedCloudFiles.length === 0
                ) {
                    setSnackbarMessage(
                        'Please select or upload at least one source'
                    )
                    setSnackbarOpen(true)
                    return false
                }
                return true
                
            case 3:
                // setShowComplexLoader(true)
                handleGeneratingDocumentModalOpen()
                return true
                
            default:
                return true
        }
    }

    useEffect(() => {
        if (documentName) {
            updateDocument({ documentName })
        }
    }, [documentName, updateDocument])

    useEffect(() => {
        if (productName) {
            updateDocument({ productName })
        }
    }, [productName, updateDocument])

    useEffect(() => {
        if (outlineSections && outlineSections.length > 0) {
            updateDocument({ outlineSections })
        }
    }, [outlineSections, updateDocument])

    return (
        <DocumentCreationProvider>
            <Box
                className="full-width-container"
                style={{ backgroundColor: '#F9FAFB' }}
            >
                <Box className="inner-container" style={{ padding: 0 }}>
                    <Box sx={{ display: 'flex', height: 'calc(100vh - 64px)' }}>
                        {/* Left Sidebar with Stepper */}
                        {/* <Box
                            sx={{
                                width: '280px',
                                minWidth: '280px',
                                backgroundColor: '#F9FAFB',
                                padding: '32px 24px',
                                display: 'flex',
                                flexDirection: 'column',
                                transition: 'all 0.3s ease',
                            }}
                        >
                            <CustomStepper 
                                activeStep={step} 
                                steps={steps} 
                                orientation="vertical" 
                            />
                        </Box> */}

                        {/* Right Content Area */}
                        <Box
                            sx={{
                                flex: 1,
                                backgroundColor: '#F9FAFB',
                                overflowY: 'auto',
                                transition: 'all 0.3s ease',
                            }}
                        >
                            <Box sx={{ 
                                width: '100%', 
                                height: '100%', 
                                padding: '40px 64px',
                                '@media (max-width: 768px)': {
                                    padding: '24px 16px',
                                },
                                position: 'relative' 
                            }}>
                                {/* Fixed positioned stepper that matches step content positioning */}
                                <Box sx={{
                                    position: 'fixed',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    top: '104px', // Position below header
                                    zIndex: 998, // Below step content but above main content
                                    width: 'clamp(600px, 75vw, 1200px)',
                                    '@media (max-width: 768px)': {
                                        width: 'calc(75vw - 16px)',
                                        minWidth: '280px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        top: '80px',
                                    },
                                    backgroundColor: '#F9FAFB',
                                    paddingBottom: '24px',
                                }}>
                                    <HorizontalStepper steps={steps} activeStep={step} />
                                </Box>
                                {/* <ArtoslibHorizontalStepper steps={steps} activeStep={step} /> */}
                                <Fade
                                    in={true}
                                    mountOnEnter
                                    unmountOnExit
                                    timeout={{ enter: 450, exit: 0 }}
                                    easing={{
                                        enter: 'cubic-bezier(0.4, 0, 0.2, 1)',
                                        exit: 'cubic-bezier(0.4, 0, 0.2, 1)',
                                    }}
                                >
                                    <Box>
                                        {renderStepContent(step)}
                                    </Box>
                                </Fade>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>

            <SourceSelectionModal
                open={sourceModalOpen}
                handleClose={handleSourceModalClose}
                onSourceSelect={handleSourceSelect}
                documentName={documentName}
                productName={productName}
                templateType={templateType}
                outline={outlineSections}
                id={documentId}
                handleStepChange={handleStepChange}
                setError={setError}
                orgId={org}
                org_name={orgs[0].orgName}
                selectedFileNames={selectedCloudFileNames}
                initialSelectedFiles={selectedCloudFiles.map((file) => ({
                    ...file
                }))}
                getOrgAccessToken={() => getOrgAccessToken(orgs[0].orgId)}
                // allowedFolders={['input', 'output', 'templates']}
                allowedFolders={['input']}
                allowedSelectedFileTypes={['pdf', 'docx', 'doc', 'txt', 'csv', 'xls', 'xlsx', 'ppt', 'pptx']}
            />

            <SourceSelectionModal
                open={contextModalOpen}
                handleClose={handleContextModalClose}
                onSourceSelect={handleContextSelect}
                documentName={documentName}
                documentType={templateType}
                setError={setError}
                orgId={orgs[0].orgId}
                org_name={orgs[0].orgName}
                isMultiSelect={false}
                initialSelectedFiles={selectedContextCloudFiles.map(
                    (file) => ({
                        ...file,
                        url: inputFiles.find(
                            (f) => f.name === file.name
                        )?.url,
                    })
                )}
                getOrgAccessToken={() =>
                    getOrgAccessToken(orgs[0].orgId)
                }
                onFilesUploaded={handleFilesUploaded}
                // allowedFolders={['input', 'output', 'templates']}
                allowedFolders={['input']}
            />

            <SourceSelectionModal
                open={tflModalOpen}
                handleClose={handleTFLModalClose}
                onSourceSelect={handleTFLCloudFileSelect}
                documentName={documentName}
                productName={productName}
                templateType={templateType}
                outline={outlineSections}
                id={documentId}
                handleStepChange={handleStepChange}
                setError={setError}
                orgId={org}
                org_name={orgs[0].orgName}
                selectedFileNames={selectedTFLCloudFileNames}
                initialSelectedFiles={selectedTFLCloudFiles.map((file) => ({
                    ...file,
                    url: inputFiles.find((f) => f.name === file.name)?.url,
                }))}
                getOrgAccessToken={() => getOrgAccessToken(orgs[0].orgId)}
                // allowedFolders={['input', 'output', 'templates']}
                allowedFolders={['input']}
            />

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert
                    onClose={() => setSnackbarOpen(false)}
                    severity="warning"
                    sx={{ width: '100%' }}
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
            
            <GeneratingDocumentModal
                open={generatingDocumentModalOpen}
                onClose={handleGeneratingDocumentModalClose}
                loading={loading}
                success={success}
                error={status === 'error'}
                errorMessage={snackbarMessage}  
                onSuccess={() => {
                    // navigate(`/documentSet/${documentSetId}`)
                }}
                onError={() => {
                    // Error handling is done in handleGenerateDocument
                }}
            />
        </DocumentCreationProvider>
    )
}
